<template>
  <div class="product-page">
    <!-- 顶部操作栏 -->
    <el-card class="tool-card" shadow="never">
      <div class="tool-row">
        <div class="tool-left">
          <span class="tool-title">商品管理</span>
          <span class="tool-sub">默认售价 + 可售区间 + 原价，订单创建时按商品绑定协议模板生成协议</span>
        </div>
        <el-button type="primary" icon="el-icon-plus" @click="openEdit(null)">新增商品</el-button>
      </div>
    </el-card>

    <!-- 列表 -->
    <el-card class="table-card" shadow="never">
      <el-table
        v-loading="loading"
        :data="list"
        :header-cell-style="{ background: '#F7F9FC', color: '#18233C', fontWeight: 600 }"
        empty-text="暂无商品"
      >
        <el-table-column label="商品" min-width="220">
          <template slot-scope="{ row }">
            <div class="pd-main">
              <div class="pd-cover">
                <img v-if="row.cover" :src="resolveAsset(row.cover)" class="pd-cover-img" alt="封面" />
                <i v-else class="el-icon-picture-outline pd-cover-ph"></i>
              </div>
              <div class="pd-info">
                <div class="pd-name">{{ row.name }}</div>
                <div v-if="templateName(row.template_id)" class="pd-tpl">协议模板：{{ templateName(row.template_id) }}</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="原价" width="110" align="right">
          <template slot-scope="{ row }">
            <span class="price-muted">¥ {{ fmtMoney(row.original_price) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="默认售价" width="120" align="right">
          <template slot-scope="{ row }">
            <span class="price-main">¥ {{ fmtMoney(row.price) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="可售区间" min-width="160" align="center">
          <template slot-scope="{ row }">
            <span class="range-num">{{ fmtMoney(row.min_price) }} ~ {{ row.max_price > 0 ? fmtMoney(row.max_price) : '上限' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="排序" width="70" align="center">
          <template slot-scope="{ row }">
            <span class="weigh">{{ row.weigh }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="90" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="parseInt(row.status) === 1 ? 'success' : 'info'" size="small">
              {{ parseInt(row.status) === 1 ? '在售' : '下架' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150" align="center">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="openEdit(row)">编辑</el-button>
            <el-button type="text" size="small" class="del-btn" @click="doDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 新增/编辑弹窗 -->
    <el-dialog :title="editId ? '编辑商品' : '新增商品'" :visible.sync="editVisible" width="640px">
      <el-form ref="form" :model="form" :rules="rules" label-width="110px" size="small">
        <div class="form-grid">
          <el-form-item label="商品名称" prop="name">
            <el-input v-model="form.name" placeholder="请输入商品名称" :maxlength="100" />
          </el-form-item>
          <el-form-item label="默认售价" prop="price">
            <el-input-number v-model="form.price" :min="0" :max="99999999" :precision="2" :step="100" style="width: 100%" />
          </el-form-item>
          <el-form-item label="可售低价" prop="min_price">
            <el-input-number v-model="form.min_price" :min="0" :max="99999999" :precision="2" :step="100" style="width: 100%" />
          </el-form-item>
          <el-form-item label="可售高价">
            <el-input-number v-model="form.max_price" :min="0" :max="99999999" :precision="2" :step="100" style="width: 100%" />
            <div class="form-hint">0 表示无上限</div>
          </el-form-item>
          <el-form-item label="商品原价">
            <el-input-number v-model="form.original_price" :min="0" :max="99999999" :precision="2" :step="100" style="width: 100%" />
          </el-form-item>
          <el-form-item label="绑定协议模板">
            <el-select v-model="form.template_id" placeholder="不绑定" clearable filterable style="width: 100%">
              <el-option v-for="t in templateOptions" :key="t.id" :label="t.name" :value="t.id" />
            </el-select>
          </el-form-item>
        </div>
        <el-form-item label="商品封面">
          <div class="cover-row">
            <el-upload
              class="cover-uploader"
              action="/api/upload/index"
              name="file"
              :headers="uploadHeaders"
              :show-file-list="false"
              :on-success="onCoverSuccess"
              :on-error="() => $message.error('封面上传失败')"
              accept="image/*"
            >
              <div class="cover-box">
                <img v-if="form.cover" :src="resolveAsset(form.cover)" class="cover-img" alt="封面" />
                <i v-else class="el-icon-plus cover-plus"></i>
              </div>
            </el-upload>
            <div class="cover-actions">
              <el-button v-if="form.cover" type="text" size="small" class="del-btn" @click="form.cover = ''">移除</el-button>
              <div class="form-hint">建议 16:9 比例图片，选填</div>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="商品简介">
          <el-input v-model="form.content" type="textarea" :rows="3" :maxlength="500" placeholder="选填" />
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.weigh" :min="0" :max="9999" style="width: 200px" />
        </el-form-item>
        <el-form-item label="状态">
          <el-switch v-model="form.status" active-text="在售" inactive-text="下架" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="editVisible = false">取 消</el-button>
        <el-button type="primary" size="small" :loading="saving" @click="doSave">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { productList, productSave, productDelete } from '@/api/base'
import { templateList } from '@/api/agreement'
import { API_BASE } from '@/config'

const ASSET_BASE = API_BASE.replace(/\/api\/?$/, '')

export default {
  name: 'ProductList',
  data() {
    return {
      list: [],
      loading: false,
      editVisible: false,
      editId: 0,
      saving: false,
      templateOptions: [],
      form: {
        name: '', price: 0, min_price: 0, max_price: 0, original_price: 0,
        cover: '', template_id: null, content: '', weigh: 0, status: true
      },
      rules: {
        name: [
          { required: true, message: '请填写商品名称', trigger: 'blur' },
          { max: 100, message: '最多 100 字', trigger: 'blur' }
        ],
        price: [{ required: true, message: '请设置默认售价', trigger: 'change' }],
        min_price: [{ required: true, message: '请设置可售低价', trigger: 'change' }]
      }
    }
  },
  computed: {
    uploadHeaders() {
      const token = this.$store.state.token || localStorage.getItem('crm_token') || ''
      return { Token: token }
    }
  },
  created() {
    this.load()
    this.loadTemplates()
  },
  methods: {
    load() {
      this.loading = true
      productList({})
        .then(data => { this.list = data.list || [] })
        .catch(() => { this.list = [] })
        .finally(() => { this.loading = false })
    },
    loadTemplates() {
      templateList()
        .then(data => { this.templateOptions = (data && data.list) || [] })
        .catch(() => { this.templateOptions = [] })
    },
    resolveAsset(url) {
      if (!url) return ''
      if (/^https?:\/\//.test(url)) return url
      if (/^data:/.test(url)) return url
      if (/^\//.test(url)) return ASSET_BASE + url
      return url
    },
    templateName(id) {
      if (!id) return ''
      const t = this.templateOptions.find(x => parseInt(x.id) === parseInt(id))
      return t ? t.name : ''
    },
    fmtMoney(n) {
      return parseFloat(n || 0).toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
    openEdit(row) {
      if (row) {
        this.editId = row.id
        this.form = {
          name: row.name,
          price: parseFloat(row.price) || 0,
          min_price: parseFloat(row.min_price) || 0,
          max_price: parseFloat(row.max_price) || 0,
          original_price: parseFloat(row.original_price) || 0,
          cover: row.cover || '',
          template_id: row.template_id ? parseInt(row.template_id) : null,
          content: row.content || '',
          weigh: parseInt(row.weigh) || 0,
          status: parseInt(row.status) === 1
        }
      } else {
        this.editId = 0
        this.form = {
          name: '', price: 0, min_price: 0, max_price: 0, original_price: 0,
          cover: '', template_id: null, content: '', weigh: 0, status: true
        }
      }
      this.editVisible = true
    },
    onCoverSuccess(res) {
      if (res && res.data && res.data.url) {
        this.form.cover = res.data.url
        this.$message.success('封面上传成功')
      } else {
        this.$message.error('封面上传失败')
      }
    },
    doSave() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.saving = true
        productSave({
          id: this.editId,
          name: this.form.name.trim(),
          price: this.form.price,
          min_price: this.form.min_price,
          max_price: this.form.max_price || 0,
          original_price: this.form.original_price || 0,
          cover: this.form.cover,
          template_id: this.form.template_id || 0,
          content: (this.form.content || '').trim(),
          weigh: this.form.weigh,
          status: this.form.status ? 1 : 0
        })
          .then(() => {
            this.$message.success(this.editId ? '修改成功' : '新增成功')
            this.editVisible = false
            this.load()
          })
          .catch(() => {})
          .finally(() => { this.saving = false })
      })
    },
    doDelete(row) {
      this.$confirm(`确认删除商品「${row.name}」？`, '删除商品', {
        confirmButtonText: '删 除',
        cancelButtonText: '取 消',
        type: 'warning'
      }).then(() => {
        productDelete(row.id)
          .then(() => {
            this.$message.success('删除成功')
            this.load()
          })
          .catch(() => {})
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.product-page { padding: 0; }

.tool-card {
  margin-bottom: 14px;
  border-radius: 10px;
  border: 1px solid #E5E9F2;
}

.tool-row { display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 10px; }
.tool-left { display: flex; align-items: baseline; gap: 12px; }
.tool-title { font-size: 15px; font-weight: 700; color: #18233C; }
.tool-sub { font-size: 12px; color: #8A94AD; }

.table-card { border-radius: 10px; border: 1px solid #E5E9F2; }

.pd-main { display: flex; align-items: center; gap: 12px; }
.pd-cover { width: 56px; height: 40px; border-radius: 6px; overflow: hidden; flex-shrink: 0; background: #F2F5FB; display: flex; align-items: center; justify-content: center; }
.pd-cover-img { width: 100%; height: 100%; object-fit: cover; display: block; }
.pd-cover-ph { font-size: 16px; color: #B4BDCF; }
.pd-name { font-size: 13px; font-weight: 600; color: #18233C; }
.pd-tpl { font-size: 11px; color: #8A94AD; margin-top: 2px; }

.price-muted { color: #B4BDCF; }
.price-main { font-size: 14px; font-weight: 700; color: #3668FC; }
.range-num { font-size: 12px; color: #5A6580; }
.weigh { color: #5A6580; }
.del-btn { color: #E5484D; }

.form-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 0 16px; }
.form-hint { font-size: 11px; color: #B4BDCF; margin-top: 2px; }

.cover-row { display: flex; align-items: flex-start; gap: 14px; }
.cover-uploader { display: inline-block; }
.cover-box {
  width: 160px; height: 90px;
  border: 1px dashed #C3CADB; border-radius: 8px;
  cursor: pointer; overflow: hidden;
  display: inline-flex; align-items: center; justify-content: center;
  background: #FAFBFF; transition: border-color 0.2s;
}
.cover-box:hover { border-color: #3668FC; }
.cover-plus { font-size: 22px; color: #8A94AD; }
.cover-img { width: 100%; height: 100%; object-fit: cover; display: block; }
.cover-actions { display: flex; flex-direction: column; align-items: flex-start; gap: 6px; }

::v-deep .el-button--primary { background: #3668FC; border-color: #3668FC; }
::v-deep .el-button--primary:hover,
::v-deep .el-button--primary:focus { background: #5B8DFF; border-color: #5B8DFF; }
::v-deep .el-table__row:hover > td { background: #F5F8FF !important; }
::v-deep .el-dialog { border-radius: 12px; }
</style>